import { render, staticRenderFns } from "./SucessBookAssigmentModification.vue?vue&type=template&id=ce458ab2&scoped=true&"
import script from "./SucessBookAssigmentModification.vue?vue&type=script&lang=js&"
export * from "./SucessBookAssigmentModification.vue?vue&type=script&lang=js&"
import style0 from "./SucessBookAssigmentModification.vue?vue&type=style&index=0&id=ce458ab2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce458ab2",
  null
  
)

export default component.exports